import React, { useEffect, useState }   from 'react';
import ResiFormLayout                   from '../../../components/ResiFormLayout';
import BuildIcon                        from '@mui/icons-material/Build';
import CustomTextFieldAggiungi          from '../../../components/fields/CustomTextFieldAggiungi';
import CustomNoteAggiungi               from '../../../components/fields/CustomNoteAggiungi';
import CustomDragAndDrop                from '../../../components/fields/CustomDragAndDrop';
import axios                            from 'axios';
import { useNavigate }                  from 'react-router-dom';
import CustomDatePickerAggiungi         from '../../../components/fields/CustomDatePickerAggiungi';
import { useTranslation }               from 'react-i18next';
import SendEmail                        from '../../../components/SendEmail';
import SendAvviso                       from '../../../components/SendAvviso';
import CustomAutocomplete               from '../../../components/fields/CustomAutocomplete';
import dayjs                            from 'dayjs';
import CircularProgressWithLabel        from '../../../components/CircularProgressWithLabel';

import { 
    Grid, 
    Button, 
    Box, 
    Alert,
    Typography,
} from '@mui/material';
import ApiService from '../../../components/service/ApiService';

const RiparazioneForm = () => {

    const navigate = useNavigate();
    const {t} = useTranslation();
    const [formValues, setFormValues] = useState({
        tipologia: 'RIPARAZIONE',
        numeroFattura: '',
        dataFattura: '',
        skuEan: '',
        imeiSerial: '',
        descrizione: '',
        numeroFatturaReal: '',
        dataCreazioneRMA: dayjs().format('DD/MM/YYYY'),
        quantita: null,
        descrizioneProblema: '',
        richiestaIndirizzo: false,
        stato: null,
        compagniaTrasporto: null,
        id: null,
        dannoFisico: null,
        idReso: null,
        infoAggiuntive: null,
        numeroFatturaClienteFinale: null,
        merceFirmataRiserva: null,
        dataRicezioneMerce: null,
        dataFatturaClienteFinale: null,
        possessoResocontoTecnico: null,
        merceDanneggiate: null,
        prodotti: null
    });
    const [alert,                       setAlert                    ] = useState({ open: false, message: '', severity: 'success' });
    const [errors,                      setErrors                   ] = useState({});
    const [uploadedFiles,               setUploadedFiles            ] = useState([]);
    const [loading,                     setLoading                  ] = useState(false);
    const [progress,                    setProgress                 ] = useState(0);
    const [message,                     setMessage                  ] = useState('');
    const [snackbarSeverity,            setSnackbarSeverity         ] = useState('success');
    const [fattureOptions,              setFattureOptions           ] = useState([]);
    const [skuOptions,                  setSkuOptions               ] = useState([]);
    const [skuDetails,                  setSkuDetails               ] = useState([]);
    const [isFatturaSelected,           setIsFatturaSelected        ] = useState(false);
    const [isFetchingFatturaDetails,    setIsFetchingFatturaDetails ] = useState(false);



    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const headers = {
        Authorization: `Bearer ${token}`
    };
    const IDCustomerRMT = user?.idRiba;  
    const ragioneSociale = user?.ragioneSociale;
    const id = user?.IDCustomerRMT;


    const fetchFatture = async () => {
        setLoading(true);
        try {
            // const response = await axios.get(`http://localhost:8080/cliente/riba/fatture/${id}`, { headers: headers });
            const response = await ApiService.request("getFatture", { id: id});
            
            
            if (response.data?.code === 200 && Array.isArray(response.data.result)) {
                const today = dayjs();
                const twoYearsAgo = today.subtract(2, "year");
                const fattureOptions = response.data.result.map((fattura) => {
                    const formattedDate = dayjs(fattura.DateInvoice, "YYYYMMDD"); 
                    const formattedDateString = formattedDate.format("DD/MM/YYYY"); 
                                        
                    return {
                        label: `${fattura.InvoiceNr} - ${formattedDateString}`,
                        value: fattura.InternalIDInvoice, 
                        numeroFattura: fattura.InvoiceNr,
                        dataFattura: formattedDate,
                    }
                })
                .filter((fattura) => fattura.dataFattura.isAfter(twoYearsAgo))
                .reverse();
                
                setFattureOptions(fattureOptions);
            } else {
                console.error("La risposta non contiene un array valido in `result`:", response.data);
            }
        } catch (error) {
            console.error("Errore durante il fetch delle fatture!", error);
        } finally {
            setLoading(false);
        }
    };
    
useEffect(() => {
    fetchFatture();
}, []);



useEffect(() => {
    let timer;

    if (loading) {
        setProgress(0); 
            timer = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 100) {
                clearInterval(timer); 
                setLoading(false); 
                return 100;
                }
            return prevProgress + 10; 
            });
        }, 300); 
    }

    return () => clearInterval(timer);
}, [loading]);


    const handleInputChange = (input) => {
        setFormValues({
            ...formValues,
            ...input,
        });
        setErrors({
            ...errors,
            ...Object.keys(input).reduce((acc, key) => {
                if (input[key] === '') {
                    acc[key] = 'Questo campo è obbligatorio';
                } else {
                    delete errors[key];
                }
                return acc;
            }, {}),
        });
    };

    const handleFilesAdded = (files) => {
        setUploadedFiles(files);
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    //funzione per la validazione dei campi
    const validateFields = (values, mandatoryFields) => {
        let errors = {};
        mandatoryFields.forEach((field) => {
            if (!values[field]) {
                errors[field] = t("Questo campo è obbligatorio");
            }
        });
        return errors;
    };


    const handleResetFileNames = () => {
        setUploadedFiles([]); 
    };

    const campiObbligatori = ["numeroFattura", "dataFattura", "skuEan", "imeiSerial", "descrizione", "descrizioneProblema"];

    const fields = [
        { label: t('Numero della fattura'),                    name: 'numeroFattura',          type: 'select',      options: fattureOptions         , disabled: false               },
        // { label: t('Data della fattura'),                      name: 'dataFattura',            type: 'date'                                         , disabled: true                },
        { label: t('SKU/EAN del prodotto'),                    name: 'skuEan',                 type: 'select',      options: skuOptions             , disabled: !isFatturaSelected  },
        { label: t('IMEI o SERIAL NUMBER'),                    name: 'imeiSerial',             type: 'text'                                         , disabled: !isFatturaSelected  },
        { label: t('Descrizione del prodotto'),                name: 'descrizione',            type: 'note',        multiline: true, rows: 4        , disabled: true                },
        { label: t('Descrizione del problema riscontrato'),    name: 'descrizioneProblema',    type: 'note',        multiline: true, rows: 4        , disabled: !isFatturaSelected  }
    ];    


    const handleFatturaChange = async (fieldValue) => {
        setLoading(true);
        setIsFetchingFatturaDetails(true);

        const numeroFattura = fieldValue.numeroFattura;

        const selectedFattura = fattureOptions.find(
            (fattura) => fattura.value === numeroFattura
        );
        
        setFormValues((prevValues) => ({
            ...prevValues,
            numeroFattura: fieldValue.numeroFattura,
            numeroFatturaReal: selectedFattura ? selectedFattura.label.split(" - ")[0] : null,
            dataFattura: fieldValue.dataFattura,
        }));

        setIsFatturaSelected(!!numeroFattura);

        try {
            const response = await axios.get(
                `/cliente/riba/dati/fattura/${numeroFattura}`,
                { headers: headers }
            );
    
            if (response.data?.code === 200 && Array.isArray(response.data.result)) {
                const fatturaDettagli = response.data.result; 
                setSkuDetails(fatturaDettagli);
                const skuOptions = fatturaDettagli.map((item) => ({
                    label: item.SKU, 
                    value: item.SKU,
                }));

                setSkuOptions(skuOptions);
                const firstItem = fatturaDettagli[0];
                const deliveryDateFormatted = dayjs(firstItem.DeliveryDate, "YYYYMMDD").format("DD/MM/YYYY");
                setFormValues((prevValues) => ({
                    ...prevValues,
                    dataFattura: deliveryDateFormatted,
                }));
            } else {
                console.error("La risposta non contiene un array valido in `result`:", response.data);
            }
        } catch (error) {
            console.error("Errore durante il fetch dei dettagli della fattura!", error);
        } finally {
            setLoading(false);
            setIsFetchingFatturaDetails(false);
        }
    };

        const handleSkuChange = (fieldValue) => {
            const matchingSkuDetails = skuDetails.filter((item) => item.SKU === fieldValue.skuEan);
        
            if (matchingSkuDetails.length > 0) {
            const combinedSerials = matchingSkuDetails
                .flatMap((item) => item.Serials || []) 
                .filter((serial) => serial);
        
            setFormValues((prevValues) => ({
                ...prevValues,
                skuEan: fieldValue.skuEan,
                descrizione: matchingSkuDetails[0].Description, 
            }));
            } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                skuEan: fieldValue.skuEan,
                descrizione: "",
            }));
            }
        };
        

    const renderFields = (field) => {
        const { name, label, type, ...otherProps } = field;

        switch (type) {
            case 'text':
                return (
                    <CustomTextFieldAggiungi
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        {...otherProps}
                    />
                );
            case 'date':
                return (
                    <CustomDatePickerAggiungi
                        key={name}
                        name={name}
                        label={label}
                        type="date"
                        values={formValues}
                        onChange={handleInputChange}
                        minDate={"01/01/1995"}
                        {...otherProps}
                    />
                );

                case "select":
                    return (
                    <CustomAutocomplete
                        name={name}
                        label={label}
                        options={field.options}
                        value={formValues[field.name] || null}
                        onChange={(fieldValue) => {
                            if (name === "numeroFattura") handleFatturaChange(fieldValue);
                            if (name === "skuEan") handleSkuChange(fieldValue);
                            setFormValues((prev) => ({ ...prev, ...fieldValue }));
                        }}
                        getOptionSelected={(option, value) => option.value === value.value}
                        {...otherProps}
                    />
                    );

            case 'note':
                return (
                    <CustomNoteAggiungi
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        {...otherProps}
                    />
                );
            default:
                return null;
        }
    };

    const handleSubmit = async () => {
        try {
            const validationErrors = validateFields(formValues, campiObbligatori);
            if (Object.keys(validationErrors).length > 0) {
                setErrors(validationErrors);
                return;
            }

            const prodotti = [
                {
                    descrizione: formValues.descrizione || "",
                    skuEan: formValues.skuEan || "",
                    imeiSerial: formValues.imeiSerial || "",
                    quantita: formValues.quantita || null,
                },
            ];

            const { descrizione, skuEan, imeiSerial, quantita, ...newFormValues } = formValues;
    

            const datiDaInviare = {
                ...newFormValues,
                prodotti,
                // idCliente: idCliente
            };

            // const response = await axios.post(`http://localhost:8080/rma/salva/${idCliente}`, datiDaInviare, { headers: headers });
            const response = await ApiService.request("rmaClienteSave", {IDCustomerRMT: IDCustomerRMT}, datiDaInviare);

            if (response.status === 200) {
            
            const id = response.data;

            try {
                if (uploadedFiles.length > 0) {
                    const formDataIMG = new FormData();
                    uploadedFiles.forEach(file => formDataIMG.append("file", file));
                    // const responseFile = await axios.post(`http://localhost:8080/rma/salva/file/${id}`, formDataIMG, {
                    //     headers: {
                    //         "Content-Type": "multipart/form-data",
                    //         Authorization: `Bearer ${token}`,
                    //     }
                    // });
                    const responseFile = await ApiService.request("fileSave", { id: id}, formDataIMG, { "Content-Type": "multipart/form-data" })
                    
                } else {
                    // const responseNullFile = await axios.post(`http://localhost:8080/rma/salva/file/${id}`, null, {
                    //     headers: {
                    //         "Content-Type": "application/json",
                    //         Authorization: `Bearer ${token}`,
                    //     }
                    // });
                    const responseFile = await ApiService.request("fileSave", { id: id}, null, { "Content-Type": "multipart/form-data" })
                    
                }

            setAlert({ open: true, message: t('Reso inviato con successo!'), severity: 'success' });
            setTimeout(() => setAlert({ ...alert, open: false }), 6000);
            setFormValues({});
            // const responseRMACreata = await axios.get(`http://localhost:8080/rma/${id}`, { headers: headers});
            const responseRMACreata = await ApiService.request("getRmaID", { idRma: id});
            
            const idReso = responseRMACreata.data?.idReso;
            
            if(idReso) {
            handleSendEmailAvviso(idReso);
            }
            setTimeout(() => {
                window.history.back();
            }, 1000); 
        } catch (error) {
            setAlert({ open: true, message: t('Errore durante l\'invio del reso.'), severity: 'error' });
            setTimeout(() => setAlert({ ...alert, open: false }), 6000);
        }
    }
        } catch (error) {
            setAlert({ open: true, message: t('Errore durante l\'invio del reso.'), severity: 'error' });
            setTimeout(() => setAlert({ ...alert, open: false }), 6000);
        }
    };

        // Funzione per la validazione dei campi obbligatori e dei file
        const validateForm = () => {
            const fieldErrors = validateFields(formValues, campiObbligatori);
            const hasFiles = uploadedFiles.length > 0;
            return Object.keys(fieldErrors).length === 0 && hasFiles;
        };

        const handleSendEmailAvviso = (idReso) => {
            const idResoDaInviare = idReso
            const destinatario = 'andrearizza6@gmail.com'
            const idDestinatario = 1 
            const messaggio = t('Creazione nuovo RMA tipo Riparazione') + ` #${idResoDaInviare} ` + t('da parte di') + ` ${ragioneSociale}`;
            const messaggioCreazioneRMA = null;
            /* invio email */
            // SendEmail(
            //     idResoDaInviare,
            //     destinatario,
            //     messaggio,
            //     'NUOVA_RMA',
            //     () => {
            //         setMessage(t('Email di contatto inviata con successo!'));
            //         setSnackbarSeverity('success');
            //     },
            //     () => {
            //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
            //         setSnackbarSeverity('error');
            //     },
            // );

                // SendEmail(
                //     idResoDaInviare,
                //     destinatario,
                //     messaggioCreazioneRMA,
                //     'CREAZIONE_RMA',
                //     () => {
                //         setMessage(t('Email di contatto inviata con successo!'));
                //         setSnackbarSeverity('success');
                //     },
                //     () => {
                //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
                //         setSnackbarSeverity('error');
                //     }
                // );
    
            // Invio avviso
            SendAvviso(
                idResoDaInviare,
                idDestinatario,
                'NUOVA_RMA',
    
                () => {
                    setMessage(t('Avviso inviato al cliente con successo!'));
                    setSnackbarSeverity('success');
                },
                () => {
                    setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                    setSnackbarSeverity('error');
                }
            )
        };

    return (
        <ResiFormLayout
            color1="#28334B"
            color2="#263F78"
            icon={<BuildIcon sx={{ fontSize: 40, color: 'white' }} />}
            title={t("Riparazione")}
            onBackClick={handleBackClick}
        >
            <form>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 4
                }}>
                    <Grid container spacing={2}>
                        {fields.map((field) => (
                            <Grid
                                item
                                xs={12}
                                sm={field.type === 'note' ? 12 : 6}
                                key={field.name}
                            >
                                {renderFields(field)}
                            </Grid>
                        ))}

                        <Grid item xs={12}>
                            <Typography variant='h6'>{t('Prova di quanto indicato: Foto e/o video o resoconto del servizio tecnico ufficiale')}</Typography>
                            <CustomDragAndDrop
                                id="fileInputRiparazione"
                                onFilesAdded={handleFilesAdded}
                                enabled={true}
                                onResetFiles={handleResetFileNames}
                            />

                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    onClick={() => handleSubmit(formValues)}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        width: '150px',
                                        background: validateForm() ? 'linear-gradient(135deg, #28334B, #263F78)' : 'gray',
                                        boxShadow: "10px 10px 10px rgba(0, 0, 0, 0.1)",
                                        borderRadius: '10px',
                                        "&:hover": {
                                            background: validateForm() ? 'linear-gradient(135deg, #28334B, #263F78)' : 'gray',
                                            transform: validateForm() ? 'scale(1.05)' : 'none',
                                        }
                                    }}
                                    disabled={!validateForm()}
                                    >
                                    {t('Invia')}
                                </Button>

                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </form>
            {alert.open && (
                <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, open: false })}
                sx={{
                    position: 'fixed',
                    top: 20, 
                    left: '50%',
                    transform: 'translateX(-50%)', 
                    zIndex: 9999, 
                    minWidth: '300px',
                    maxWidth: '600px',
                }}
                >
                    {alert.message}
                </Alert>
            )}
            {/* Loader al centro */}
            {(loading || isFetchingFatturaDetails) &&  (
                <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'rgba(217, 217, 217, 0.56)',
                    zIndex: 9999,
                }}
                >
                <CircularProgressWithLabel value={progress} />
                </Box>
            )}
        </ResiFormLayout>
    );
};

export default RiparazioneForm;
